<template functional>
  <div
    class="editor placeholder"
  >
    {{ props.message }}
  </div>
</template>

<script>
export default {
  name: 'Placeholder',
  props: {
    message: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.placeholder {
  position: absolute;
  width: calc(100% - 40px) !important;
  height: calc(100% - 40px) !important;
  margin: 0 !important;
  padding: 20px;
  top: 20px;
  left: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px dashed #fff;
  color: #fff;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.5em;
  letter-spacing: 0.5pt;
  cursor: pointer;
  border-radius: 3px;
}
</style>
